<ng-template
  let-notification="data"
  #template>
  <header>
    <h3>{{ notification?.title | transloco }}</h3>
  </header>
  <p>{{ notification?.content | transloco }}</p>

  @if (notification.actionBtnTextI18n) {
    <footer>
      <ui-platform-button
        [label]="notification.actionBtnTextI18n | transloco"
        (click)="notification.action()"></ui-platform-button>
    </footer>
  }
</ng-template>
